export enum MediaState {
  LOADING = 'loading',
  READY = 'ready',
  DISABLED = 'disabled',
  ERROR = 'error',
}

export const DEFAULT_ASPECT_RATIO = { width: 16, height: 9 };

/**
 * Bounds on the aspect ratios we'll accept from the video SDK, wide enough for
 * anything from a 9:21 phone to a 21:9 ultrawide. Ratios outside this range
 * would produce cells too tall or too wide for the grid to lay out sensibly.
 */
export const MIN_ASPECT_RATIO = 1 / 3;
export const MAX_ASPECT_RATIO = 3;
